import { useIntl } from 'react-intl';
import { REPLAYS_NOTES } from '../../../../../../../../../../modules/passport-pages/config';
import { DefaultPageViewModel } from '../../../default-page.viewmodel';

export const useReplaysNotes = (pageVm: DefaultPageViewModel) => {
    const { formatMessage } = useIntl();

    const replaysNotesEntity = pageVm.getFieldConfigByKey(REPLAYS_NOTES);
    const replaysNotesLabelText = formatMessage(replaysNotesEntity.labelDescriptor);
    const replaysNotes = pageVm.getFieldByKey(REPLAYS_NOTES);

    const handleReplaysNotesChange = (_e: unknown, editor: { getData(): string }) =>
        pageVm.setFieldValueByKey(REPLAYS_NOTES, editor.getData());

    const handleReplaysNotesBlur = () => pageVm.setValueTouched(REPLAYS_NOTES);

    return {
        replaysNotes: replaysNotes,
        replaysNotesEntity: replaysNotesEntity,
        replaysNotesLabelText: replaysNotesLabelText,
        handleReplaysNotesChange: handleReplaysNotesChange,
        handleReplaysNotesBlur: handleReplaysNotesBlur,
    };
};